import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

import { HANDPICKED_ROUTE_PATH } from '../components/shared/constants';

const HandpickedRoute = (
  <Route
    key={HANDPICKED_ROUTE_PATH}
    path={HANDPICKED_ROUTE_PATH}
    handle={{
      clientSide: true,
      pageName: MParticlePageName.Handpicked,
    }}
    lazy={async () => ({
      Component: (await import(
        /* webpackChunkName: 'marketplace' */
        '../components/marketplace/marketplace_page_wrapper'
      )).default,
    })}
  />
);

export default HandpickedRoute;
